@for (line of rowInputs; track line) {
<div>
  {{ line }}
</div>
} @for (line of rowInputsToTranslate; track line) {
<div>
  {{ line | translate }}
</div>
}
<div>
  @for (entry of inlineInputsToTranslate; track entry) {
  {{ entry | translate }} &nbsp; } @for (entry of inlineInputs; track entry) { {{ entry | translate }} &nbsp; }
</div>
